/** Keys used for browser storage. Prefixed to avoid collisions. */

const PREFIX = 'kvo';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: `${PREFIX}:access_token`,
  REFRESH_TOKEN: `${PREFIX}:refresh_token`,
  USER: `${PREFIX}:user`,
  SIDEBAR: `${PREFIX}:sidebar`,
  THEME: `${PREFIX}:theme`,
  SIDEBAR_COLLAPSED: `${PREFIX}:sidebar_collapsed`,
};

export default STORAGE_KEYS;
